// Attribuzione delle campagne (Google Ads / UTM) per i lead del form contatti.
// I parametri si leggono sempre dall'URL corrente (con Consent Mode url_passthrough il gclid
// arriva anche sulle pagine interne); vengono salvati in localStorage solo se l'utente ha
// accettato i cookie di terze parti, e scadono dopo 90 giorni (finestra di conversione di Google Ads).

var STORAGE_KEY = "idc_attribution";
var TTL_MS = 90 * 24 * 60 * 60 * 1000;
var PARAMS = ["gclid", "gbraid", "wbraid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function hasConsent() {
	try {
		return localStorage.cookieconsent === "true";
	} catch (e) {
		return false;
	}
}

function fromUrl() {
	var query = new URLSearchParams(window.location.search);
	var found = {};
	PARAMS.forEach(function (p) {
		var v = query.get(p);
		if (v) {
			found[p] = v.substring(0, 255);
		}
	});
	if (!Object.keys(found).length) {
		return null;
	}
	found.landing_page = window.location.pathname.substring(0, 255);
	found.ts = Date.now();
	return found;
}

function fromStorage() {
	if (!hasConsent()) {
		return null;
	}
	try {
		var stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
		if (stored && Date.now() - stored.ts < TTL_MS) {
			return stored;
		}
		localStorage.removeItem(STORAGE_KEY);
	} catch (e) {}
	return null;
}

// Da chiamare al caricamento e subito dopo che l'utente concede il consenso.
function persist() {
	var current = fromUrl();
	if (!current || !hasConsent()) {
		return;
	}
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
	} catch (e) {}
}

// Ultimo clic: i parametri dell'URL corrente vincono su quelli salvati.
function get() {
	var a = fromUrl() || fromStorage();
	if (!a) {
		return {};
	}
	var out = {};
	PARAMS.concat(["landing_page"]).forEach(function (p) {
		if (a[p]) {
			out[p] = a[p];
		}
	});
	return out;
}

persist();

module.exports = { get: get, persist: persist };
